"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var flattenDeep_1 = require("../../utils/flattenDeep");
var toKeyValueArray_1 = require("../../utils/toKeyValueArray");
var toValueArray_1 = require("../../utils/toValueArray");
var AcceptedCookiesStrategy_1 = require("../AcceptedCookiesStrategy");
var InMemoryAcceptedCookies = /** @class */ (function (_super) {
    __extends(InMemoryAcceptedCookies, _super);
    function InMemoryAcceptedCookies(INTERNAL_API_URL, VERSION_FILES_JS, req) {
        var _this = _super.call(this, INTERNAL_API_URL, VERSION_FILES_JS) || this;
        _this.req = req;
        return _this;
    }
    InMemoryAcceptedCookies.prototype.GetLastVersion = function () {
        return InMemoryAcceptedCookies.lastVersion[this.INTERNAL_API_URL];
    };
    InMemoryAcceptedCookies.prototype.GetLastUpdateTime = function () {
        return InMemoryAcceptedCookies.lastUpdateTime[this.INTERNAL_API_URL];
    };
    InMemoryAcceptedCookies.prototype.Get = function (acceptedCategories) {
        var acceptedCategoriesParsed;
        try {
            acceptedCategoriesParsed = acceptedCategories || JSON.parse(this.req.cookies["cookie-info"]);
        }
        catch (e) {
            /* Ignore errors for JSON.parse in case this.req.cookies is undefined */
        }
        var allAcceptedCookies = InMemoryAcceptedCookies.allCookies[this.INTERNAL_API_URL];
        if (!allAcceptedCookies) {
            return null;
        }
        return flattenDeep_1.default(toKeyValueArray_1.default(allAcceptedCookies)
            .filter(function (_a) {
            var key = _a.key;
            return !acceptedCategoriesParsed || acceptedCategoriesParsed[key];
        })
            .map(function (_a) {
            var value = _a.value;
            return toValueArray_1.default(value);
        }));
    };
    InMemoryAcceptedCookies.prototype.SaveAcceptedCookies = function (acceptedCookies) {
        console.warn("Method not necessary in this strategy. This had no effect.");
    };
    InMemoryAcceptedCookies.prototype.saveCookiesDictionary = function (acceptedCategories, cookiesDictionary) {
        InMemoryAcceptedCookies.allCookies[this.INTERNAL_API_URL] = cookiesDictionary;
    };
    InMemoryAcceptedCookies.prototype.setLastUpdate = function () {
        InMemoryAcceptedCookies.lastUpdateTime[this.INTERNAL_API_URL] = new Date();
    };
    InMemoryAcceptedCookies.prototype.setLastVersion = function () {
        InMemoryAcceptedCookies.lastVersion[this.INTERNAL_API_URL] = this.VERSION_FILES_JS;
    };
    InMemoryAcceptedCookies.lastVersion = {};
    InMemoryAcceptedCookies.lastUpdateTime = {};
    InMemoryAcceptedCookies.allCookies = {};
    return InMemoryAcceptedCookies;
}(AcceptedCookiesStrategy_1.default));
exports.default = InMemoryAcceptedCookies;
//# sourceMappingURL=InMemoryAcceptedCookies.js.map